import { render, staticRenderFns } from "./SchoolActivityModal.vue?vue&type=template&id=fd13a7f2&scoped=true"
import script from "./SchoolActivityModal.vue?vue&type=script&lang=js"
export * from "./SchoolActivityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd13a7f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd13a7f2')) {
      api.createRecord('fd13a7f2', component.options)
    } else {
      api.reload('fd13a7f2', component.options)
    }
    module.hot.accept("./SchoolActivityModal.vue?vue&type=template&id=fd13a7f2&scoped=true", function () {
      api.rerender('fd13a7f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolActivity/modules/SchoolActivityModal.vue"
export default component.exports